import React from 'react';
import dataMindLogo from '@/assets/images/data-mind-logo.svg';

interface SimpleChartPopoverProps {
  isVisible: boolean;
  position: { x: number; y: number };
  data: {
    label: string;
    value: number;
    color: string;
    name: string;
  } | null;
}

export const SimpleChartPopover: React.FC<SimpleChartPopoverProps> = ({ 
  isVisible, 
  position, 
  data
}) => {
  if (!isVisible || !data) {
    return null;
  }

  // Calculate position to keep popover within viewport
  const calculatePosition = () => {
    const popoverWidth = 180;
    const popoverHeight = 80;
    const padding = 10;
    const offset = 15;

    let x = position.x + offset;
    let y = position.y - offset - 50;

    // Keep within viewport bounds
    if (typeof window !== 'undefined') {
      if (x + popoverWidth > window.innerWidth - padding) {
        x = position.x - popoverWidth - offset;
      }
      if (y + popoverHeight > window.innerHeight - padding) {
        y = position.y - popoverHeight - offset;
      }
      if (y < padding) {
        y = position.y + offset;
      }
      if (x < padding) {
        x = position.x + offset;
      }
    }

    return { x, y };
  };

  const adjustedPosition = calculatePosition();

  return (
    <div
      className="fixed z-[9999] pointer-events-none"
      style={{
        left: adjustedPosition.x,
        top: adjustedPosition.y,
      }}
    >
      <div className="bg-white dark:bg-[#52606d] border border-gray-200 dark:border-[#2f3844] rounded-lg shadow-lg p-3 min-w-[160px] opacity-90">
        {/* Header with label only - no time formatting */}
        <div className="text-xs font-medium text-gray-600 dark:text-[#8b98a5] pb-2 mb-2 border-b border-gray-100 dark:border-[#2f3844] flex justify-between items-center gap-2">
          <span>{data.label}</span>
          <img src={dataMindLogo} className="h-3" />
        </div>

        {/* Value */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-[0.3rem] h-4" style={{ backgroundColor: data.color }} />
            <span className="text-gray-700 dark:text-[#e1e8ed] font-medium text-sm">{data.name}</span>
          </div>
          <div className="text-gray-900 dark:text-gray-100 font-semibold text-sm">
            {data.value.toLocaleString()}
          </div>
        </div>
      </div>
    </div>
  );
};